import { render, staticRenderFns } from "./RedEnvelopeEditor.vue?vue&type=template&id=f3bc95aa&scoped=true&"
import script from "./RedEnvelopeEditor.vue?vue&type=script&lang=js&"
export * from "./RedEnvelopeEditor.vue?vue&type=script&lang=js&"
import style0 from "./RedEnvelopeEditor.vue?vue&type=style&index=0&id=f3bc95aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bc95aa",
  null
  
)

export default component.exports